<h1 mat-dialog-title style = "color:red">Warning</h1>
<div mat-dialog-content>
    <p style ="margin: 10px; color: red;">Are you sure you want to continue? this month already has shifts!</p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onYesClick()" cdkFocusInitial>Yes</button>
    <button mat-button (click)="onNoClick()">No</button>
  </div>